<domain-detail [domain]="domain" [name]="name" (helperOutput)="finalizeRequest($event)" [updateChangeRequest]="updateChangeRequest"
               *ngIf="domain && !confirmChanges && !submitConfirmation" [requestMetadata]="requestMetadata"></domain-detail>

<review-changes [domain]="domain" *ngIf="domain &&  confirmChanges && !submitConfirmation" [requestMetadata]="requestMetadata" [updateChangeRequest]="updateChangeRequest"
                (decision)="reviewDecision($event)"></review-changes>

<submit-confirmation *ngIf="domain &&  submitConfirmation" [showTicketNumber]="showTicketNumber()"
                     [requestConfirmation]="requestConfirmation"
                     [updateChangeRequest]="updateChangeRequest" [domainName]="domain.name"
                     [newDelegation]="requestMetadata.requestType === 'NEW'" [requestMetadata]="requestMetadata"></submit-confirmation>
